export function cloneDeep(value) {
  return JSON.parse(JSON.stringify(value))
}

export function isNil(value) {
  return [undefined, null].includes(value)
}
